export const roundNumber = (value: number, decimals: number) => {
  const num = Number(Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals).toFixed(decimals));
  if (!num) return 0;
  return num;
};
